/* eslint-disable no-inline-comments */
/* eslint-disable capitalized-comments */
// ========================= IMPORT DEPENDENCIES ========================= //

import {bootstrap} from '@mvps-genesis/bootstrap';
import Global from 'pages/Global';

// ========================= RUN MAIN SCRIPT ========================= //

bootstrap({

	// Pass your MVT to JS namespace
	context: window.mivaJS,

	// Global Page class
	globalClass: Global,

	// A directory of page classes or scss files to be loaded by matching the `Page_Code` context variable
	pageCodeImports: {
		ABAL: () => import(/* webpackChunkName: "page-code--ABAL" */'pages/ABAL/ABAL.js'),
		ACAD: () => import(/* webpackChunkName: "page-code--ACAD" */'pages/ACAD/ACAD.js'),
		ACED: () => import(/* webpackChunkName: "page-code--ACED" */'pages/ACED/ACED.js'),
		ACLN: () => import(/* webpackChunkName: "page-code--ACLN" */'pages/ACLN/ACLN.js'),
		AFAD: () => import(/* webpackChunkName: "page-code--AFAD" */'pages/AFAD/AFAD.js'),
		AFCL: () => import(/* webpackChunkName: "page-code--AFCL" */'pages/AFCL/AFCL.js'),
		AFED: () => import(/* webpackChunkName: "page-code--AFED" */'pages/AFED/AFED.js'),
		AFFR: () => import(/* webpackChunkName: "page-code--AFFR" */'pages/AFFR/AFFR.js'),
		AFPW: () => import(/* webpackChunkName: "page-code--AFPW" */'pages/AFPW/AFPW.js'),
		AFRT: () => import(/* webpackChunkName: "page-code--AFRT" */'pages/AFRT/AFRT.js'),
		AUTNOT: () => import(/* webpackChunkName: "page-code--AUTNOT" */'pages/AUTNOT/AUTNOT.js'),
		'BA-APP': () => import(/* webpackChunkName: "page-code--BA-APP" */'pages/BA-APP/BA-APP.js'),
		'BALANCE-GRID': () => import(/* webpackChunkName: "page-code--BALANCE-GRID" */'pages/BALANCE-GRID/BALANCE-GRID.js'),
		BASK: () => import(/* webpackChunkName: "page-code--BASK" */'pages/BASK/BASK.js'),
		CABK: () => import(/* webpackChunkName: "page-code--CABK" */'pages/CABK/CABK.js'),
		CADA: () => import(/* webpackChunkName: "page-code--CADA" */'pages/CADA/CADA.js'),
		CADE: () => import(/* webpackChunkName: "page-code--CADE" */'pages/CADE/CADE.js'),
		CEML: () => import(/* webpackChunkName: "page-code--CEML" */'pages/CEML/CEML.js'),
		CPCA: () => import(/* webpackChunkName: "page-code--CPCA" */'pages/CPCA/CPCA.js'),
		CPCD: () => import(/* webpackChunkName: "page-code--CPCD" */'pages/CPCD/CPCD.js'),
		CPCE: () => import(/* webpackChunkName: "page-code--CPCE" */'pages/CPCE/CPCE.js'),
		CPWD: () => import(/* webpackChunkName: "page-code--CPWD" */'pages/CPWD/CPWD.js'),
		CSBE: () => import(/* webpackChunkName: "page-code--CSBE" */'pages/CSBE/CSBE.js'),
		CSTR: () => import(/* webpackChunkName: "page-code--CSTR" */'pages/CSTR/CSTR.js'),
		CSUB: () => import(/* webpackChunkName: "page-code--CSUB" */'pages/CSUB/CSUB.js'),
		CTLG: () => import(/* webpackChunkName: "page-code--CTLG" */'pages/CTLG/CTLG.js'),
		CTUS: () => import(/* webpackChunkName: "page-code--CTUS" */'pages/CTUS/CTUS.js'),
		CTYPE_EDIT: () => import(/* webpackChunkName: "page-code--CTYPE_EDIT" */'pages/CTYPE_EDIT/CTYPE_EDIT.js'),
		'DISC-ACCT': () => import(/* webpackChunkName: "page-code--DISC-ACCT" */'pages/DISC-ACCT/DISC-ACCT.js'),
		'DISC-LIST': () => import(/* webpackChunkName: "page-code--DISC-LIST" */'pages/DISC-LIST/DISC-LIST.js'),
		'DISC-REC': () => import(/* webpackChunkName: "page-code--DISC-REC" */'pages/DISC-REC/DISC-REC.js'),
		'DISC-SNGL': () => import(/* webpackChunkName: "page-code--DISC-SNGL" */'pages/DISC-SNGL/DISC-SNGL.js'),
		'ET-CB': () => import(/* webpackChunkName: "page-code--ET-CB" */'pages/ET-CB/ET-CB.js'),
		'FORM-ERROR': () => import(/* webpackChunkName: "page-code--FORM-ERROR" */'pages/FORM-ERROR/FORM-ERROR.js'),
		GFTL: () => import(/* webpackChunkName: "page-code--GFTL" */'pages/GFTL/GFTL.js'),
		'GUIDE-SINGLE': () => import(/* webpackChunkName: "page-code--GUIDE-SINGLE" */'pages/GUIDE-SINGLE/GUIDE-SINGLE.js'),
		'ID-PART': () => import(/* webpackChunkName: "page-code--ID-PART" */'pages/ID-PART/ID-PART.js'),
		INVC: () => import(/* webpackChunkName: "page-code--INVC" */'pages/INVC/INVC.js'),
		LOGN: () => import(/* webpackChunkName: "page-code--LOGN" */'pages/LOGN/LOGN.js'),
		MNTN: () => import(/* webpackChunkName: "page-code--MNTN" */'pages/MNTN/MNTN.js'),
		NTFD: () => import(/* webpackChunkName: "page-code--NTFD" */'pages/NTFD/NTFD.js'),
		OCST: () => import(/* webpackChunkName: "page-code--OCST" */'pages/OCST/OCST.js'),
		OPAY: () => import(/* webpackChunkName: "page-code--OPAY" */'pages/OPAY/OPAY.js'),
		ORDBAL: () => import(/* webpackChunkName: "page-code--ORDBAL" */'pages/ORDBAL/ORDBAL.js'),
		ORDH: () => import(/* webpackChunkName: "page-code--ORDH" */'pages/ORDH/ORDH.js'),
		ORDL: () => import(/* webpackChunkName: "page-code--ORDL" */'pages/ORDL/ORDL.js'),
		ORDS: () => import(/* webpackChunkName: "page-code--ORDS" */'pages/ORDS/ORDS.js'),
		ORHL: () => import(/* webpackChunkName: "page-code--ORHL" */'pages/ORHL/ORHL.js'),
		OSEL: () => import(/* webpackChunkName: "page-code--OSEL" */'pages/OSEL/OSEL.js'),
		PLST: () => import(/* webpackChunkName: "page-code--PLST" */'pages/PLST/PLST.js'),
		QUOH: () => import(/* webpackChunkName: "page-code--QUOH" */'pages/QUOH/QUOH.js'),
		QUOT: () => import(/* webpackChunkName: "page-code--QUOT" */'pages/QUOT/QUOT.js'),
		'RETURN-REQUEST': () => import(/* webpackChunkName: "page-code--RETURN-REQUEST" */'pages/RETURN-REQUEST/RETURN-REQUEST.js'),
		RGFT: () => import(/* webpackChunkName: "page-code--RGFT" */'pages/RGFT/RGFT.js'),
		S880: () => import(/* webpackChunkName: "page-code--S880" */'pages/S880/S880.js'),
		'S880-order': () => import(/* webpackChunkName: "page-code--S880-order" */'pages/S880-order/S880-order.js'),
		SRCH: () => import(/* webpackChunkName: "page-code--SRCH" */'pages/SRCH/SRCH.js'),
		swisco_support: () => import(/* webpackChunkName: "page-code--swisco_support" */'pages/swisco_support/swisco_support.js'),
		TERMS: () => import(/* webpackChunkName: "page-code--TERMS" */'pages/TERMS/TERMS.js'),
		'VIDEO-SINGLE': () => import(/* webpackChunkName: "page-code--VIDEO-SINGLE" */'pages/VIDEO-SINGLE/VIDEO-SINGLE.js'),
		WISH: () => import(/* webpackChunkName: "page-code--WISH" */'pages/WISH/WISH.js'),
		WLAD: () => import(/* webpackChunkName: "page-code--WLAD" */'pages/WLAD/WLAD.js'),
		WLED: () => import(/* webpackChunkName: "page-code--WLED" */'pages/WLED/WLED.js'),
		WLGN: () => import(/* webpackChunkName: "page-code--WLGN" */'pages/WLGN/WLGN.js'),
		WLST: () => import(/* webpackChunkName: "page-code--WLST" */'pages/WLST/WLST.js')
	},

	// A directory of page classes or scss files to be loaded by matching the `Screen` or `Page_Code` context variable against a regular expression
	regexImports: {},

	// A directory of page classes or scss files to be loaded by matching the `Screen` context variable
	screenImports: {
		CTGY: () => import(/* webpackChunkName: "page-code--CTGY" */'pages/CTGY/CTGY.js'),
		PROD: () => import(/* webpackChunkName: "page-code--PROD" */'pages/PROD/PROD.js')
	}

});
